import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Google Maps API key - consider storing this in .env file for security
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_kEY;

export const locationApi = createApi({
    reducerPath: "locationApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://maps.googleapis.com/maps/api/",
    }),
    endpoints: (builder) => ({
        searchLocations: builder.query({
            query: (searchQuery) =>
                `place/textsearch/json?key=${GOOGLE_API_KEY}&query=${encodeURIComponent(searchQuery)}`,
            transformResponse: (response) => {
                if (!response.results || response.status !== "OK") {
                    return [];
                }

                return response.results.map((place) => ({
                    display_name: place.name,
                    lat: place.geometry.location.lat,
                    lon: place.geometry.location.lng,
                    place_id: place.place_id,
                    formatted_address: place.formatted_address,
                    name: place.name,
                }));
            },
        }),
    }),
});

export const { useSearchLocationsQuery, useLazySearchLocationsQuery } = locationApi;